/**
 * PageHelper
 *
 * Mixin that exposes some methods and computed properties to help manage the query params
 */
export default {

    computed: {
        page() {
            return this.$route.query?.page || 0;
        },
        query() {
            return this.$route.query;
        }
    },

    data() {
        return {
            previous_route_query: {},
        };
    },

    methods: {
        /**
         * Removes a variable from the query string
         *
         * @param {string} key
         */
        removeQueryParam(key) {
            let query = Object.assign({}, this.$route.query) || {};

            if ( key in query ) {
                delete query[key];
                this.$router.replace({ query });
            }
        },

        /**
         * Gets a value from the query params
         *
         * @param {string} key
         * @param {*} default_value
         * @return {*}
         */
        getQueryParam(key, default_value = null) {
            return this.$route.query?.[key] ?? default_value;
        },

        /**
         * Adds params to the query
         *
         * @param {object} params
         */
        addQueryParams(params) {
            this.previous_route_query = {...this.$route.query};
            this.$router.replace({ query: Object.assign({}, this.$route.query, params) });
        },

        /**
         * Adds a single param to the query
         *
         * @param {string} key
         * @param {number|string} value
         */
        addQueryParam(key, value) {
            this.addQueryParams({
                [key]: value,
            });
        },

        revertQueryParams() {
            this.$router.replace({ query: {...this.previous_route_query} });
            this.previous_route_query = {};
        },

        /**
         * Adds or removes a param to the query at key based on its value.
         *
         * @param {string} key
         * @param {number|string} value
         */
        updateQueryParam(key, value) {
            if ( [undefined, null, ''].includes(value) ) {
                this.removeQueryParam(key);
            } else {
                this.addQueryParam(key, value);
            }
        },
    }
}
